import React from "react";
import { UserProfilePictureIcon } from "./icons/Icons";
import styles from "./ProfileIcon.module.css";
/**
 * Reusable profile icon component that can show either:
 * - User initials (from first/last name), or
 * - A profile image, when profileUrl is provided (hook up when backend is ready).
 *
 * Props:
 * - profileUrl?: string | null
 * - firstName: string
 * - lastName: string
 * - size?: number (pixel size for the icon/avatar, defaults to 28)
 * - className?: string (optional wrapper styles)
 * - initialsClassName?: string (optional styles for initials text)
 */
const ProfileIcon = ({
    profileUrl = null,
    firstName,
    lastName,
    size = 28,
}) => {
    const initials = `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();

    const getInitialsSize = (size) => {
        if (size <= 28) {
            return 10;
        } else if (size <= 32) {
            return 12;
        } else {
            return 14;
        }
    };

    const initialsFontSize = getInitialsSize(size);

    return (
        <div className={styles.icon}>
            {profileUrl ? (
                <img
                    src={profileUrl}
                    alt="User Profile"
                    style={{
                        width: `${size}px`,
                        height: `${size}px`,
                        borderRadius: '50%',
                        border: '2px solid grey',
                        objectFit: 'cover'
                    }}
                />
            ) : (
                <>
                    <span
                        className={styles.initials}
                        style={{ fontSize: `${initialsFontSize}px` }}
                    >
                        {initials}
                    </span>
                    <UserProfilePictureIcon width={String(size)} height={String(size)} />
                </>
            )}
        </div>
    );
};

export default ProfileIcon;

